module.exports = __webpack_public_path__ + "static/umd-4d7e5fe799dd54e9643bb3655ab9cbf5.jpg";